export const CONFIG = {
	API_URL: process.env.REACT_APP_API_URL,
	API_ORDER_URL: process.env.REACT_APP_ORDER_URL,
	API_RESTAURANT_URL: process.env.REACT_APP_RESTAURANT_URL,
	API_USER_URL: process.env.REACT_APP_USER_URL,
	API_AUTH_URL: process.env.REACT_APP_AUTH_URL,
	API_EMAIL_URL: process.env.REACT_APP_EMAIL_URL,
	IMG_URL: process.env.REACT_APP_IMG_URL,
	IMG_GET_URL: process.env.REACT_APP_IMG_GET_URL,
	ENV: process.env.REACT_APP_ENV,
	PORT: process.env.REACT_APP_PORT,
	RECAPTCHA_SITE_KEY_PUBLIC: process.env.REACT_APP_RECAPTCHA_SITE_KEY_PUBLIC,
	TINY_MCE_API_KEY: process.env.REACT_APP_TINY_MCE_KEY,
	API_URL_NEW: process.env.REACT_APP_API_URL_NEW,
	GEOCODE_API_KEY: process.env.REACT_APP_GEOCODE_API_KEY,
	PRIVATE_KEY: process.env.REACT_APP_PRIVATE_KEY,
};

export const MICROSERVICE_CONFIG = {
	AUTH: "/auth/api/v1",
	USER: "/user/api/v1",
	CUSTOMER_SUPPORT: "/customer-support/api/v1",
	NOTIFICATION: "/notification/api/v1",
	RESTAURANT: "/restaurant/api/v1",
	ACCOUNTING: "/accounting/api/v1",
	GIFT: "/gift/api/v1",
	SUPERADMIN_BFF: "/admin-web/api/v1",
};

export const ROLES_CONFIG = {
	ADMIN: 1,
	RESTAURANT: 2,
	USER: 3,
};

export const USERS_TABS = {
	ONBOARDED: "Onboarded Users",
	PENDING: "Pending Registration",
	GUEST: "Guest Users",
	REFERRALS: "Referrals",
};
